export default {
    temporary: {} //临时数据
}